/**
 * Module depenencies.
 */

import { InnovationBlock } from 'src/types/innovation-block';
import countriesSvg from 'src/assets/svg/countries.svg';
import cylindersSvg from 'src/assets/svg/cylinders.svg';
import manufactureSvg from 'src/assets/svg/manufacture.svg';

/**
 * Export `TeamMember` type.
 */

export type TeamMember = {
  name: string;
  role: string;
};

/**
 * `Config` type.
 */

type Config = {
  innovationBlocks: InnovationBlock[];
  teamMembers: TeamMember[];
};

/**
 * Export `contentConfig`.
 */

export const contentConfig: Config = {
  innovationBlocks: [
    {
      description:
        'about-us:sections.manufacture.blocks.manufacture.description',
      icon: manufactureSvg,
      title: 'about-us:sections.manufacture.blocks.manufacture.title'
    },
    {
      description: 'about-us:sections.manufacture.blocks.countries.description',
      icon: countriesSvg,
      title: 'about-us:sections.manufacture.blocks.countries.title'
    },
    {
      description: 'about-us:sections.manufacture.blocks.cylinders.description',
      icon: cylindersSvg,
      title: 'about-us:sections.manufacture.blocks.cylinders.title'
    }
  ],
  teamMembers: [
    {
      name: 'Filipe Pedrosa',
      role: 'General Manager'
    },
    {
      name: 'Frédéric Gaussen',
      role: 'Senior Director\nLPG'
    },
    {
      name: 'Mikaël Azevedo',
      role: 'Sales Manager\nLPG'
    },
    {
      name: 'Pedro Sousa',
      role: 'Sales Manager\nLPG'
    },
    {
      name: 'Manuel Lopes',
      role: 'Sales Manager\nTechnical Gases'
    },
    {
      name: 'Filipe Cernadas',
      role: 'Sales Manager\nHigh Pressure Cylinders'
    },
    {
      name: 'Vitor Scarton',
      role: 'Sales Manager\nBalloon Time'
    },
    {
      name: 'Milos Morbitzer',
      role: 'Sales Manager\nBalloon Time'
    }
  ]
};
